import { render, staticRenderFns } from "./bomImgDialog.vue?vue&type=template&id=b0089f2c&scoped=true"
import script from "./bomImgDialog.vue?vue&type=script&lang=js"
export * from "./bomImgDialog.vue?vue&type=script&lang=js"
import style0 from "./bomImgDialog.vue?vue&type=style&index=0&id=b0089f2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0089f2c",
  null
  
)

export default component.exports